import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Component Error:', error, errorInfo);
    // Add error logging to your backend here if needed
  }

  render() {
    return this.state.hasError
      ? this.props.fallback || (
          <div className="p-4 bg-red-50 text-red-600">
            Something went wrong. Please refresh the page.
          </div>
        )
      : this.props.children;
  }
}